<template>
<div
  v-if="articles.length > 0"
  class="other-news"
>
  <div class="other-news__title h3 semibold">Другие статьи</div>
  <div class="other-news__list">
    <nuxt-link
      v-for="(article) in articles"
      :key="`news-card-${ article.id }`"
      :to="article.url"
      class="news-card"
    >
      <div class="news-card__image">
        <nuxt-img
          :src="String(article.imageId)"
          :width="120"
          :height="120"
          :placeholder="true"
          fit="cover"
          :alt="`${article.title}-image-${article.imageId}`"
        />
      </div>
      <div class="news-card__content">
        <div class="news-card__title h5">
          {{ article.title }}
        </div>
        <div class="news-card__link">
          <div class="h6">Читать статью</div>
        </div>
      </div>
    </nuxt-link>
  </div>
</div>
</template>

<script setup lang="ts">
import { ArticleItem, type IArticleItem } from '#sitis/internal/controllers/articles/models/ArticleItem';

interface IProps {
  articleId: number | null;
  articleCategoryId?: number | null;
}

const props = withDefaults(defineProps<IProps>(), {
  articleId: null,
  totalPages: null
});
const { $api } = useNuxtApp();

const articles: Ref<IArticleItem[]> = ref([]);
const getArticles = async () => {
  let search: string[] = [
    'per-page=3'
  ];
  if (props.articleCategoryId) {
    search.push(`filter[category_id]=${ props.articleCategoryId }`);
  }
  const _res: any[] = await $api.agent.get(`/articles?${ search.join('&') }`).then((res) => {
    return res._data
  }).catch(() => {
    return []
  });
  articles.value = _res.filter((_item: any) => _item.id !== props.articleId).map((_item: any) => new ArticleItem(_item));
};
onMounted(async () => {
  await getArticles();
});
</script>

<style scoped lang="scss">
.other-news {}
.other-news__title {
  margin-bottom: 24px;
}
.other-news__list {
  display: flex;
  flex-direction: column;

  & > * {
    margin-top: 24px;
  }
}

.news-card {
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    .news-card__link div {
      text-decoration-color: transparent;
    }
  }
}
.news-card__image {
  width: 100%;
  max-width: 120px;
  border-radius: 6px;
  position: relative;
  background-color: #EEEDED;
  margin-right: 24px;
  overflow: hidden;

  img {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    object-fit: cover;
  }
  &:after {
    content: "";
    float: left;
    padding-top: 100%;
  }
}
.news-card__content {
  flex: 1;
}
.news-card__title {
  color: black;
}
.news-card__link {
  margin-top: 16px;

  div {
    color: #989898;
    text-decoration: underline;
  }
}

@media (max-width: 1023px) {
  .other-news__title {
    margin-bottom: 0;
    font-size: 18px;
  }
}
</style>
